// source https://bobbyhadz.com/blog/replace-plain-urls-with-links-using-javascript
export function getTextWithLinks(text: string) {
    const expressionWithHttp = /(https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*))/gi;
    const regex = new RegExp(expressionWithHttp);
    return text.replace(regex, "<a href='$1' target='blank' rel='noreferrer noopener'>$1</a>");
}
